export default function(callback) {
  if (!window.intl) {
    require.ensure([
      'intl',
      'intl/locale-data/jsonp/en.js',
      'intl/locale-data/jsonp/es.js',
    ], (require) => {
      require('intl');
      require('intl/locale-data/jsonp/en.js');
      require('intl/locale-data/jsonp/es.js');
      callback();
    });

    return;
  }

  callback();
}



// WEBPACK FOOTER //
// ./src/lib/ensure-intl.js